/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

export default {
  re_title: '会议预约',
  title_log: '智能会议',
  //弹出框的国际化
  dialog_btn_ok: '确定',
  dialog_btn_cancel: '取消',
  dialog_btn_know: '知道了',
  dialog_prompt_info: '提示信息',
  dialog_warning_info: '警示信息',
  dialog_error_info: '错误提示',
  dialog_success_info: '提交成功',
  country_china: '中国 +86',
  country_china_hk: '中国香港 +852',

  count: '数量',
  num_of_day: "天数",

  btn_close: '关闭',
  btn_approval: '通过',
  btn_reject: '拒绝',
  btn_save: '保存',

  topic: '主题',

  pls_select: '请选择',

  //首页国际化
  index_registration: '免费注册',
  index_company: '公司',
  index_company_name: '公司名称',
  index_company_domain: '公司域名',
  index_company_account: '申请人帐号',
  index_company_email: '申请人邮箱',
  index_company_phone: '申请人电话',

  index_username: '姓名',
  index_email: '邮箱',
  index_phone: '手机',
  index_staffID: 'Staff ID',
  index_image_content: '图片内容',
  index_password_prompt: '密码（8位以上数字及大小写字母组合）',
  index_password_conform: '确认密码（8位以上数字及大小写字母组合）',
  index_agree: '同意软件使用许可协议',
  index_previous: '上一步',
  index_next: '下一步',
  index_login_username: '用户名',
  index_login_password: '密码',
  index_login_basedn: '域',
  index_login_check_code: '验证码',
  index_remember: '记住密码',
  index_forgot: '忘记密码?',
  index_register_account: '注册新账户',
  index_un_username: '用户名不能为空,请重新输入',
  index_un_password: '密码不能为空,请重新输入',
  index_find_password: '找回密码',
  index_find_email: '邮箱找回',
  index_send: '发送',
  index_or: '或',
  index_find_phone: '手机找回',
  index_valid_code: '获取验证码',
  index_valid_prompt: '邮箱验证：请确认邮箱地址是否正确',
  index_submit: '提交',

  continue_extend: '继续延长',

  index_activation: '激活',
  index_tip_email: '邮箱验证',
  index_valid_phone: '手机验证',
  index_tip_email_title: '邮箱验证',
  index_valid_phone_title: '手机验证',
  index_complete: '完成',

  index_reset_password: '重置密码',
  index_save_continue: '保存并继续',

  index_logo_virsical: '威思客',
  index_login: '登录',
  index_reservation_platform: '智能会议',
  index_help: '帮助',
  index_download: '下载中心',
  index_language_shift: '中/英文切换',
  index_language_chinese: '简体中文',
  index_language_chineseHk: '繁体中文',
  index_language_english: '英文',
  index_login_off: '注销',
  index_domain_success: '新域已成功注册，请激活后登录！',
  index_domain_msm: '验证码已发送，请查收！',
  emil_sent: '邮件已发送，请查收！',
  index_experience: '马上体验',
  index_experience_0: '马',
  index_experience_1: '上',
  index_experience_2: '体',
  index_experience_3: '验',
  index_select_number: '选择人数',
  index_select_0: '不限',
  index_select_1: '1-3人',
  index_select_2: '4-9人',
  index_select_3: '10+人以上',
  index_search: '搜索',
  index_reset: '重置',
  index_un_resource: '请选择所预约资源类型',
  index_un_start: '请选开始时间',
  index_un_end: '请选择结束时间',
  index_un_number: '请选择预约人数',
  index_search_beijing: '北京',
  startPlaceholder: '开始日期',
  endPlaceholder: '结束日期',

  start_greater_than_end: '开始时间不能大于结束时间',
  start_greater_then_end_one_month: '查询时间不能大于一个月',
  main_search_content: '会议室',
  main_pc_contact: '联系人',
  main_pc_location: '位置',
  main_content_index: '首页',
  main_content_workspace: '会议预约',
  main_meeting_available: '可用',
  main_meeting_book: '预约',
  main_meeting_more: '展开更多',
  main_meeting_startTime: '会议时间',
  main_meeting_endTime: '结束时间',
  main_meeting_attends: '参会人数',
  main_meeting_disuse: '弃用',
  main_meeting_attends_list: '参会人名单',
  main_meeting_sign: '签到人数',
  main_meeting_sign_rate: '签到率',
  main_meeting_type: '类型',
  main_meeting_room_manager: '会议室管理员',
  main_meeting_use: '使用规定',
  main_meeting_attend: '参会人',
  main_meeting_holder: '申请人',
  main_meeting_title: '会议主题',
  main_meeting_room: '会议室',
  main_meeting_description: '会议说明',
  main_meeting_time_length: '会议时长',
  main_meeting_notice: '会议通知',
  main_meeting_ip: 'IP话机',
  main_meeting_remark: '备注',
  main_meeting_message: '短信',
  main_meeting_cycle: '循环预订',
  main_meeting_collapse: ' 向上收起',
  main_meeting_no_data: '无数据',
  main_meeting_room_rates: '费用(元/次)',
  main_meeting_cmma_type: '会议类型',
  main_meeting_cmma_normal: '普通会议',
  main_meeting_cmma_video: '视频会议',
  main_meeting_cmma_pwd: '参会密码',
  main_meeting_cmma_pwd_wrong: '参会密码必须是数字',
  meeting_control_btn: '会控',
  cmma_msg_title: '编辑字幕',
  cmma_msg_label1: '显示时长(秒)',
  cmma_msg_empty: '请输入60字以内的消息',

  mc_table_room: '会议室',
  mc_table_region: '区域',
  mc_table_terminal: '终端',
  mc_table_number: '号码',
  mc_table_status: '状态',
  mc_table_option: '操作',
  mc_status_connected: '已连接',
  mc_status_ringing: '连接中',
  mc_status_unknown: '未连接',
  mc_extend_message1: '视频会议还有{lastMinutes}分钟结束，是否',
  mc_extend_message2: '？',
  mc_extend: '延长',
  mc_btn_start_now: '一键开启',
  mc_btn_add: '添加',
  mc_btn_mute_all: '全部静音',
  mc_btn_mute_all_cancel: '取消静音',
  mc_btn_dial: '拨号',
  mc_btn_lock: '锁定',
  mc_btn_unlock: '取消锁定',
  mc_btn_layout: '分屏',
  mc_btn_rotation: '轮询',
  mc_btn_message: '字幕',
  mc_btn_hang_up: '挂断',
  mc_btn_release: '释放',
  mc_btn_subtitle: '会议字幕',
  mc_btn_minute: '会议纪要',
  mc_btn_hold: '保留',
  mc_btn_ok: '确定',
  mc_btn_cancel: '取消',
  mc_btn_select: '选择',
  mc_btn_stop: '结束',
  mc_btn_main: '主会场',
  mc_btn_speaking: '点名发言',
  mc_btn_video: '摄像头',
  mc_btn_audio: '麦克风',
  mc_btn_redial: '重拨',
  mc_label_stop_meeting: '是否释放会议室资源？',
  mc_label_extend: '请选择延长时间',
  mc_label_room_select: '选择会议室',
  mc_label_layout_model: '分屏模式',
  mc_label_rotation_setting: '轮询设置',
  mc_label_stop_rotation: '是否结束轮询？',
  mc_layout_prefix_full: '全局布局',
  mc_layout_prefix_1_n: '1+n分屏',
  mc_layout_prefix_equal: '对等分屏',
  mc_layout_shortcut_speakerOnly: '全屏',
  mc_layout_shortcut_telepresence: '网真',
  mc_layout_shortcut_stacked: '堆叠',
  mc_layout_shortcut_allEqual: '对等分屏',
  mc_layout_speakerOnly: '全屏布局',
  mc_layout_telepresence: '网真布局',
  mc_layout_stacked: '堆叠布局',
  mc_layout_allEqual: '对等分屏',
  mc_layout_allEqualQuarters: '2*2分屏',
  mc_layout_allEqualNinths: '3*3分屏',
  mc_layout_allEqualSixteenths: '4*4分屏',
  mc_layout_allEqualTwentyFifths: '5*5分屏',
  mc_layout_onePlusN: '1+n分屏',
  mc_layout_onePlusFive: '1+5分屏',
  mc_layout_onePlusSeven: '1+7分屏',
  mc_layout_onePlusNine: '1+9分屏',
  mc_layout_current: '当前模式',
  mc_rotation_model: '轮询模式',
  mc_rotation_single: '单屏轮询',
  mc_rotation_multi: '多屏轮询',
  mc_rotation_interval: '间隔时长',
  mc_rotation_mainLayout: '主场分屏',
  mc_rotation_nums: '轮询数量',
  mc_rotation_rotas: '被轮询者',
  mc_rotation_allParticipants: '全部与会者',
  mc_rotation_dot: '、',
  mc_rotation_partiEnum: '{enumStr}等共计{num}个会议室',
  mc_msg_duplicate_number: '您呼叫的号码已经在当前会议中',
  mc_msg_at_least_one: '请选择至少一个新会议室',
  mc_msg_no_meeting: '视频会议尚未启动或已结束，无法执行此操作',
  mc_msg_main_warning: '只有创建会议时添加的会议室才可以设置为主会场',
  mc_msg_start_success: '视频会议启动成功！',
  mc_msg_start_fail_0: '视频会议启动失败，资源占用！',
  mc_msg_start_fail_1: '视频会议启动失败!',
  mc_msg_start_already: '视频会议已经启动，无需重新启动',
  mc_msg_no_meeting_start: '当前会议室没有即将开始的会议，无法一键启动',
  mc_msg_no_email_start: '当前用户未设置邮箱，无法一键启动',
  mc_msg_close_then_back: '当前视频会议已结束，已退出会控页面',
  mc_msg_calling_fail: '呼叫失败，{roomName}已被其他会议占用！',
  mc_msg_socket_error: '创建CMMA Webocket失败，十秒后发起重连',
  mc_msg_success: '操作成功，请稍候...',
  mc_subtitle_language: '语言',
  mc_subtitle_translate: '翻译',
  mc_subtitle_sublanguage: '副语言',
  mc_subtitle_language_zh: '中文-普通话',
  mc_subtitle_language_en_u: '英语-美式',
  mc_subtitle_language_en_a: '英语-澳大利亚',
  mc_subtitle_language_kr: '韩国语',
  mc_subtitle_language_jp: '日本语',
  mc_subtitle_language_my: '马来语',
  mc_subtitle_google: '仅Google支持',
  mc_asr_config_error: '视频空间配置异常',

  main_room_type: '会议室类型',
  main_room_capacity: '会议室容量',
  main_room_dept: '所属组织',
  main_room_default_dept: '默认组织',
  main_sign_type: '签到类型',
  main_is_sign: '是否签到',
  main_open_video: '直录播',
  main_notice_type: '提醒方式',

  main_meeting_room_placeholder_manager: '会议室管理员',

  main_menu_title: '威发预约平台',
  main_menu_title_new: '威思客智能会议',
  main_menu_add: '添加菜单',

  //预约
  reserve_type_video: '视频',

  carouser_welcome: '欢迎使用预约平台',
  carouser_welcome_1: '便捷和高效的使用方式，随手可用的预约工具',
  carouser_welcome_2: '日历方式呈现',
  carouser_welcome_3: '伴你随行，更加高可视和易用性。',
  carouser_welcome_4: '在线云化预约',
  carouser_welcome_5: '充分支持企业部署和云端服务模式。',
  carouser_welcome_6: '客户化设置项',
  carouser_welcome_7: '对资源和设备均支持客户化定义管理模式。',
  carouser_welcome_8: '用户角色管理',
  carouser_welcome_9: '使用，管理均支持基于角色控制和授权。',
  carouser_welcome_10: '移动设备应用',
  carouser_welcome_11: '支持基于安卓, IOS和网页端访问使用。',
  carouser_welcome_12: '分享到社交网络',
  carouser_welcome_13: '与线上朋友，随时随地的沟通',

  index_bottom_1: '功能特点',
  index_bottom_2: '日历',
  index_bottom_3: '会议室预订',
  index_bottom_4: '网络会议',
  index_bottom_5: '电话会议',
  index_bottom_6: '客户化设置',
  index_bottom_7: '用户管理',
  index_bottom_8: '统计报表',
  index_bottom_9: '移动端应用',
  index_bottom_10: '产品体验',
  index_bottom_11: '增值服务',
  index_bottom_12: '会议展板',
  index_bottom_13: '企业V话',
  index_bottom_14: '视频会议',
  index_bottom_15: '硬件设备基础',
  index_bottom_16: '价格',
  index_bottom_17: '免费版',
  index_bottom_18: '标准版',
  index_bottom_19: '增强版',
  index_bottom_20: '关于我们',
  index_bottom_21: '关于公司',
  index_bottom_22: '技术支持',
  index_bottom_23: '媒体报道',
  index_bottom_24: '联系我们',
  index_bottom_25: '扫一扫关注威思客公众号',
  index_bottom_26: '公 司：北京威发新世纪信息技术有限公司',
  index_bottom_27:
    '地 址：北京市东城区长安街1号东方广场东二办公楼19层1907-1909',
  index_bottom_28: '售前咨询：400-685-3160',
  index_bottom_29: '邮 箱：sales@virsical.com',
  index_bottom_30: '2000-2016威发系统有限公司',
  index_bottom_31: '北京威发新世纪信息技术有限公司',
  index_bottom_32:
    '推荐使用谷歌、火狐、IE10以上版本浏览器，分辨率1280*800及以上。',

  account_base_info: '个人信息',
  city_zone: '城市地区',
  account_setting: '设置',
  account_user_group: '用户管理',
  account_notice_remind: '通知提醒',
  account_server_resource: '会议室管理',
  account_domain_manage: '角色管理',
  account_role_setting: '角色设置',
  account_role_list: '角色列表',
  account_meeting_book: '会议代订',
  account_meeting_manager: '会议室管理员',
  account_Authority_restriction: '权限设置',
  account_meeting_setting: '会议代订设置',
  account_new_more_meetings: '新建同一时间预订多个会议',
  account_meeting_manager_setting: '会议室管理员设置',
  account_s: '查看所有管辖区域会议预订情况',
  account_p: '修改和取消所有管辖区域未开始会议',
  account_zone_add_value1: '请先保存，再进行新增',
  reservation_save: '保存',
  reservation_apply: '申请',
  reservation_send_notice: '发送通知',

  account_domain_address: '详细地址',
  account_domain_ems: '邮政编码',
  account_domain_telephone: '电话',
  account_domain_website: '企业网站',
  account_domain_upload: '上传LOGO',
  account_domain_css: '皮肤',
  account_domain_css_1: '暖色',
  account_domain_css_2: '小清新',
  account_domain_css_3: '自定义',
  account_domain_lang: '语言设置',
  account_domain_date: '时间设置',
  account_app_Manager: '应用管理',

  user_id: '用户ID',
  user_department: '部门',
  user_company: '公司',
  user_group: '用户组',
  user_group_unit: '人',
  user_first_name: '姓',
  user_last_name: '名',
  user_position: '职位',
  user_edit: '编辑',
  user_delete: '删除',
  user_dept_notFound: '未找到',
  user_save_prompt: '先新增或修改用户后再保存',
  user_not_edit: '该用户为同步数据，不允许编辑或删除',
  resource_not_prompt: '请先新增或者编辑后再保存',

  group_name: '名称',
  group_save_prompt: '输入用户组名称后再保存',
  group_select: '请选择用户组',
  role_select: '请选择用户角色',
  role: '用户角色',
  domain_admin: '域管理员',
  general_people: '普通用户',
  index_delete_success: '删除成功',
  index_save_success: '保存成功',
  index_save_failed: '保存失败',
  index_meeting_save_failed: '预约会议失败',
  index_sync_success: '同步成功',
  re_open: '开',
  re_close: '关',
  resource_state_open: '开锁',
  resource_state_close: '锁定',
  resource_open_open: '公开',
  resource_open_close: '私有',
  index_permission: '权限',
  index_device: '设备绑定',
  re_to: '至',
  booking_before: '提前',
  booking_minutes: '分钟',

  privilege_time_limit: '可用时间范围',
  work_time: '工作时间',
  re_from: '从',
  booking_win_num: '预订窗口',
  booking_win: '预约窗口',
  re_shift: '提前',
  lock_win: '锁定窗口',
  re_day: '天',
  re_day_mini: '天',
  re_hour: '小时',
  re_hour_mini: '小时',
  re_minutes: '分钟',
  re_min: '分钟',
  re_minutes_mini: '分钟',
  booking_number: '预订数量',
  expire_number: '未签到数量',
  used_rate: '使用率',
  self_service: '自助服务',
  workflow_approve: '流程审批',
  report_permission: '报表基本权限',
  meeting_approve: '审批',
  meeting_detail: '详情',

  cycle_booking: '循环预约',
  cycle_times: '次',
  cycle_may_booking: '可',
  bookingNum: '预约次数',
  expireNum: '弃用次数',
  max_cycle_time: '最大循环预约次数',
  max_booking_time: '最长预约时间',
  re_other_setting: '其他设置',
  re_support: '支持',
  re_sign_in: '签到',
  re_sign_out: '签出',
  re_delay_time: '延长最长时间',
  re_add: '新增',
  re_list: '列表',
  re_user: '用户',
  account_info: '账户信息',
  re_date: '时间',
  date_lang: '时间/语言设置',
  date_lang2: '时间设置',
  re_times: '次',

  re_of: '所属',
  re_assist: '辅助',
  re_assist_server: '辅助服务',
  re_equipment: '设备',
  re_service: '服务',
  tea_break: '茶歇',
  re_number: '人数',
  re_state_normal: '正常',
  re_state_fault: '故障',
  re_not_meeting: '目前没有搜索到可用资源，请更改搜索条件重新搜索',
  re_personal_concat: '个人通讯录',
  re_company_concat: '企业通讯录',
  add_external: '添加外部参会人',
  edit_external: '编辑外部参会人',
  external_user: '外部参会人',

  error_404: '哇咔咔～页面不见了～',
  error_tips: '请核对您输入的页面域名是否正确哦～',
  back_index: '返回首页',
  manual_add: '手工新增',
  excel_import: 'Excel导入',
  download_template: '模板下载',
  re_upload: '上传',
  re_selected: '浏览',
  send_invitation: '发出邀请',
  reset_password: '修改密码',
  old_password: '原始密码',
  new_password: '新密码',
  sure_password: '确认密码',
  old_password_notNull: '原始密码不能为空！',
  new_password_notNull: '新密码不能为空！',
  sure_password_notNull: '确认密码不能为空！',
  sure_pwd_notEq: '新密码与确认密码不一致！',
  new_password_tip: '8位以上，至少有一个数字和一个字母',
  new_pwd_check_err: '请输入8位以上密码，至少包含一个数字和一个字母！',
  company_info: '企业信息',
  department_info: '部门管理',
  device_info: '设备管理',
  user_init_password: '用户初始密码设置',
  init_password: '初始密码',
  init_password_not_null: '初始密码不能为空',

  my_reservation_list: '我的预约列表',
  history_list: '历史预约列表',
  reservation_list: '预约列表',
  re_week: '周',
  re_month: '月',
  re_month_mini: '月',
  re_year: '年',
  re_year_mini: '年',
  re_date_time: '会议时间',
  re_start: '开始',
  re_end: '结束',
  re_extend: '延长',
  interval_time: '持续时间',
  regular_pattern: '定期模式',
  repeat_range: '重复范围',
  no_end_time: '无结束日期',
  re_repeat: '重复',
  re_happen_time: '发生，生效时间',
  re_th: '第',
  re_every: '每',
  re_work_day: '每个工作日',
  re_week_day_new: '个工作日',
  re_week_th: ' 周的',
  re_week_thw: '周的',
  re_month_th: '个月的',
  re_first: '第一个',
  re_second: '第二个',
  re_third: '第三个',
  re_fourth: '第四个',
  re_sunday: '星期日',
  re_monday: '星期一',
  re_tuesday: '星期二',
  re_wednesday: '星期三',
  re_thursday: '星期四',
  re_friday: '星期五',
  re_saturday: '星期六',
  re_every_year: '每年',
  system_info: '系统消息',
  we_chat_info: '微信消息',
  email_info: '邮件消息',
  sms_info: 'SMS消息',
  re_template: '模板',
  notice_remind_set: '提醒时间设置',
  _30_minute: '30分钟',
  _15_minute: '15分钟',
  _10_minute: '10分钟',
  _5_minute: '5分钟',
  service_type_set: '服务资源类型设置',
  service_type_list: '服务资源类型列表',
  service_type_permission: '会议室预约权限设置',
  service_type_per_list: '会议室预约权限列表',
  service_res_set: '会议室设置',
  service_res_list: '会议室列表',
  service_fixed_device_list: '固定设备管理',
  service_mobile_device_list: '移动设备管理',
  service_res_permission: '服务资源权限设置',
  service_res_per_list: '服务资源权限列表',
  service_Exchange: '配置 Exchange 集成',
  service_Exchange_list: '配置 Exchange 集成列表',
  service_Office: '配置 office365 集成',
  service_Config: '配置服务',
  service_Exchange_protocol: '协议',
  service_Exchange_versions: '版本',
  service_Exchange_status: '状态',
  service_Exchange_describe: '描述',
  service_Exchange_account: '账号',
  service_Exchange_password: '密码',
  service_Exchange_domain: '域名',
  service_Exchange_open: '开启',
  service_Exchange_close: '关闭',
  service_exchange_connect: '连通性测试',
  sync_config: '同步配置',
  sync_config_port: '端口',
  sync_config_roots: '同步根',
  sync_config_roots_msg: "多个OU以','分隔",
  sync_config_oauthType: '认证方式',
  sync_config_oauthMethod: '认证类型',
  sync_config_encrypMode: '加密方式',
  sync_config_encrypMode_def: '不加密',
  sync_config_filter: '过滤器',

  device_modal_title: '设备绑定',
  device_modal_delete: '删除',
  device_modal_cancel: '取消',
  device_modal_save: '保存',
  device_modal_save_success: '视频设备绑定成功！',
  device_modal_save_fail: '视频设备绑定失败！',
  device_modal_delete_success: '视频设备删除成功！',
  device_modal_delete_fail: '视频设备删除失败！',
  device_modal_name: '设备名：',
  device_modal_name_ph: '视频设备名称',
  device_modal_cucmname: '识别号',
  device_modal_cucmname_ph: '思科设备请填写CUCM的Device Name',
  device_modal_model: '型号：',
  device_modal_primaryAddress: '号码：',
  device_modal_primaryAddress_ph: '视频设备号码',
  device_modal_protocol: '协议：',
  device_modal_sipEncryption: 'SIP加密：',
  device_modal_bandWidth: '带宽：',
  device_modal_qualityMains: '视频分辨率：',
  device_modal_qualityPresentation: '双流分辨率：',
  device_modal_sendDouble: '发送双流：',
  device_modal_dualStreamMode: '双流模式：',
  device_modal_bfcp: 'bfcp模式：',
  device_modal_name_less: '设备名不能少于3个字符',
  device_modal_name_more: '设备名不能超过50个字符',
  device_modal_name_required: '设备名不能为空',
  device_modal_cucmname_more: '识别号不能超过50个字符',
  device_modal_cucmname_required: '识别号不能为空',
  device_modal_model_required: '型号不能为空',
  device_modal_primaryAddress_required: '号码不能为空',
  device_modal_primaryAddress_wrong: '号码格式不正确',
  device_modal_primaryAddress_more: '号码不能超过10个字符',
  device_modal_protocol_required: '协议不能为空',
  device_modal_sipEncryption_required: 'SIP加密不能为空',
  device_modal_bandWidth_required: '带宽不能为空',
  device_modal_qualityMains_required: '视频分辨率不能为空',
  device_modal_qualityPresentation_required: '双流分辨率不能为空',
  device_modal_tip_required: 'TIP不能为空',
  device_modal_sendDouble_required: '发送双流不能为空',
  device_modal_dualStreamMode_required: '双流模式不能为空',
  device_modal_bfcp_required: 'bfcp模式不能为空',
  device_modal_item_ciscoOther: '思科其他',
  device_modal_item_thirdPart: '第三方',
  device_modal_item_required: '开启',
  device_modal_item_optional: '允许',
  device_modal_item_prohibited: '关闭',
  device_modal_item_unlimited: '无限制',
  device_modal_item_dualStream: '双通道',
  device_modal_item_singleStream: '单通道',
  device_modal_item_sandc: '服务器/客户端模式',
  device_modal_item_server: '服务器模式',

  IP_not_empty: 'IP不能为空',
  account_not_empty: '账户不能为空',
  password_not_empty: '密码不能为空',
  domain_not_empty: '域名不能为空',
  port_not_empty: '端口不能为空',
  roots_not_empty: '同步根不能为空',
  Exchange_not_empty: '请完善Exchange配置信息',

  //新增内容
  operation_items: '操作项',
  upload_avatar: '上传头像',
  user_group_setting: '用户组群',
  no_group: '无用户组群',
  user_info_prompt: '请完善用户信息的必填项',
  user_info_name: '姓和名不能同时为空',
  confirm_prompt: '请确认信息是否正确',
  reg_tel_prompt: '申请人电话格式有误',
  reg_email_prompt: '申请人邮箱格式有误',
  reg_domain_prompt: '公司域名已被注册',
  company_name_prompt: '公司名称不能为空',
  reg_account_prompt: '申请人帐号不能为空',
  company_domain_prompt: '公司域名格式不正确',
  reg_firstName_prompt: '申请人姓不能为空',
  reg_lastName_prompt: '申请人名不能为空',
  reg_userId_prompt: '申请人账号格式不正确',
  reg_password_prompt: '申请人密码不符合规则',
  uri_domain_prompt: '请在浏览器地址栏中输入域名',
  tel_error_prompt: '电话号码有误，请重新输入',
  email_error_prompt: '输入的邮箱有误，请重新输入',
  password_error_prompt: '您输入的密码格式不正确，请重新输入',
  userId_domain_prompt: '用户ID域名与浏览器URL中的域名不一致',
  had_book: '已预约',
  not_start: '未开始',
  re_going: '进行中',
  re_done: '已结束',
  re_canceled: '已取消',
  re_auditing: '审批中',
  re_audit_failed: '未批准',
  re_audit_success: '审批已通过',
  modify_loop_meeting: '修改该系列的所有循环会议?',
  cancel_loop_meeting: '取消该系列的所有循环会议?',
  cancel_normal_meeting: '确定取消此会议吗?',

  //7月21号
  sign_out_meeting: '是否结束会议',
  cancel_meeting: '取消会议',
  book_meeting_attendee: '你当前选择的参会人超过了会议室容量限制',
  delete_service_prompt: '是否需要删除当前选择的会议室？',

  not_allow_book: '不可预约',
  re_modify: '修改',
  not_allow_cycle: '不可循环',
  end_meeting_success: '结束会议成功',
  cancel_meeting_success: '取消会议成功',
  //资源类型
  resource_name_meeting: '会议预订',
  resource_name_meeting_type: '预订方式',
  resource_name_workspace: '工位预订',
  resource_name_visit: '访客预订',
  re_basic_info: '基本信息',

  //timeZoneSetting 由英文翻译过来的。
  re_time_zone_1: '(GMT -12:00) 埃尼威托克岛，夸贾林环礁',
  re_time_zone_2: '(GMT -11:00) 萨摩亚，中途岛',
  re_time_zone_3: '(GMT -10:00) 夏威夷',
  re_time_zone_4: '(GMT -9:00) 阿拉斯加',
  re_time_zone_5: '(GMT -8:00) 太平洋时间（美国及加拿大）',
  re_time_zone_6: '(GMT -7:00) 山地（美国和加拿大）',
  re_time_zone_7: '(GMT -6:00) 中央标准时间（美国和加拿大），墨西哥城',
  re_time_zone_8: '(GMT -5:00) 东部时间（美国和加拿大），波哥大，利马',
  re_time_zone_9: '(GMT -4:00) 大西洋时间（加拿大），加拉加斯，拉巴斯',
  re_time_zone_10: '(GMT -3:30) 纽芬兰岛',
  re_time_zone_11: '(GMT -3:00) 巴西，布宜诺斯艾利斯，乔治敦',
  re_time_zone_12: '(GMT -2:00) 中大西洋',
  re_time_zone_13: '(GMT -1:00 小时) 亚速尔群岛、佛得角群岛',
  re_time_zone_14: '(GMT) 欧洲西部时间、伦敦、里斯本、卡萨布兰卡',
  re_time_zone_15: '(GMT +1:00 小时) 哥本哈根皇家马德里、巴黎、布鲁塞尔',
  re_time_zone_16: '(GMT +2:00) 南非加里宁格勒',
  re_time_zone_17: '(GMT +3:00) 巴格达、利雅得、莫斯科、圣彼得堡',
  re_time_zone_18: '(GMT +3:30) 德黑兰',
  re_time_zone_19: '(GMT +4:00) 阿布扎比，马斯喀特，巴库，第比利斯',
  re_time_zone_20: '(GMT +4:30) 喀布尔',
  re_time_zone_21: '(GMT +5:00) 叶卡捷琳堡，伊斯兰堡，卡拉奇，塔什干',
  re_time_zone_22: '(GMT +5:30) 加尔各答、马德拉斯、孟买、新德里',
  re_time_zone_23: '(GMT +5:45) 加德满都',
  re_time_zone_24: '(GMT +6:00) 阿拉木图，科伦坡，达卡',
  re_time_zone_25: '(GMT +7:00) 河内市，雅加达，曼谷',
  re_time_zone_26: '(GMT +8:00) 北京，珀斯，新加坡，香港',
  re_time_zone_27: '(GMT +9:00) 东京，汉城，大阪，札幌，雅库茨克',
  re_time_zone_28: '(GMT +9:30) 阿德莱德，达尔文',
  re_time_zone_29: '(GMT +10:00) 海参崴东部，关岛，澳大利亚',
  re_time_zone_30: '(GMT +11:00) 马加丹，所罗门群岛，新喀里多尼亚',
  re_time_zone_31: '(GMT +12:00) 奥克兰，威灵顿，斐济，堪察加半岛',

  permission_message: '权限信息',
  re_cycle: '周期',
  loop_meeting: '循环会议',
  re_cycle_meeting: '周期会议',
  _24_hour: '24小时',
  attend_holder_conflict: '参会人和申请人冲突！',
  select_service: '选择服务',

  //7月28号
  upload_tips: '您上传的文件名包含特殊符号，请重新上传',
  password_different: '两次密码输入不一致',
  //8月2号
  re_login_use: '请登录使用',
  select_service_permission: '请选择服务人数',
  view_all_news: '查看所有消息',
  you_have: '你有',
  have_message_number: '条消息',
  re_ago: '前',
  re_accept: '接受',
  re_agree: '同意',
  re_refuse: '拒绝',

  //会议展板
  iShow_available: '空闲',
  iShow_occupy: '占用',
  today_events: '今日会议列表',
  iShow_book: '预订',
  no_meeting: '无会议室信息',
  current_event: '当前会议',
  end_meeting: '结束会议',
  extend_meeting: '延长会议',
  iShow_member: '参会人',
  iShow_people: '人',
  next_meeting: '下一个会议',
  upcoming_meeting: '即将开始会议',
  member_password: '请输入密码',
  please_input_invite: '请输入会议号',
  holder_password: '请输入申请人密码',
  iShow_ok: '确定',
  iShow_bind: '绑定',
  iShow_repairs: '是否需要报修？',
  meeting_email: '会议室邮箱',
  main_meeting_time: '会议时间',
  choose_time: '选择时间',
  index_un_meet: '请输入会议主题',
  index_un_attend: '请选择参会人',
  add_holder: '选择申请人',
  add_attend: '选择参会人',
  search: '搜索',
  meet_console: '会议室展板控制台',
  back: '返回',

  //消息中心
  message_dash: '消息中心',
  message_list: '消息列表',
  message_error_prompt: '请选择要删除的消息',
  message_content: '内容',
  message_receive_time: '接收时间',
  approval_check: '流程审批',
  no_check: '未审批',
  agree_check: '已审批',
  re_current: '刚刚',
  re_account: '帐户',
  sign_success: '签到成功',
  sign_out_success: '结束成功',
  re_send: '重新发送',
  re_tel_number: '电话号码',
  re_tel_validate: '验证码',
  /*手机app*/
  fill: '请填写',
  select: '请选择',
  submitDel: '您确认要删除该条记录吗？',
  submitCancel: '您确认要取消会议吗？',
  roomNum: '房间人数',
  meeting_holder: '会议主持',
  add: '添加',
  all_select: '全选',
  all: '全选',
  no_data: '没有相关数据',
  avatar: '头像',
  tel: '手机号',
  current_version: '当前版本',
  book_meetting: '预约会议',
  phone_book: '通讯录',
  inform_remind: '通知和提醒',
  inform_remind_con: '关于我的消息通知和提醒信息内容',
  mybook: '我的预约',
  history_book: '历史预约',
  mybook_con: '显示我的预约会议室列表',
  meetting_info: '会议信息',
  sweep: '扫一扫',
  sweep_con: '扫描二维码：签到和签出会议',

  app_notice: '通知',
  app_remind: '提醒',
  app_no_data: '没有相关数据',
  Weekday: '工作日',
  Everyday: '每天',
  just_start: '该功能即将发布！',

  app_notice_pull: '下拉',
  app_notice_deliver: '释放',

  //  威思客底部统一
  product_categories: '产品方案',
  smart_conference: '智能会议',
  access_management: '访客管理',
  smart_cubicle: '智能工位',
  smart_signage: '智能展板',
  smart_office_portal: '智能办公平台',
  download: '产品下载',
  download_virsical: '威思客下载',
  download_v_chat: '企业V话下载',
  download_smart_signage: '智能展板下载',
  rsources: '资源下载',
  download_product: '产品彩页下载',
  download_typical: '成功案例下载',
  interactive_center: '互动中心',
  video_center: '视频中心',
  virsical_help_center: '威思客帮助中心',
  company_profile: '公司介绍',
  partners: '合作伙伴',
  honors_qualifications: '荣誉资质',
  news: '新闻动态',
  recruitment: '招聘信息',
  index_bottom_55: '扫描下方二维码',
  index_bottom_56: '关注威思客公众号',
  piece: '个',
  day: '号',
  Num: '第',
  week: '星期',
  searchBar_clear: '取消',
  loading: '加载中...',
  read: '已阅读',
  done: '已回执',
  distance_meeting: '距离本次会议',
  wrong_Internet: '网络异常，请检查网络!',

  // meeting v4.2
  service_area: '所属区域',
  service_area_name: '区域名称',
  service_area_building_location: '楼宇位置',
  service_is_approval: '是否审批',
  service_fixed_device: '选择固定设备',
  service_fixed_device_select: '选择',
  creat_meeting: '新建会议',
  exact_search: '精确搜索',
  meeting_list: '会议管理',
  login_info: '登录您的账号',
  check_address: '请确认邮箱地址是否正确',
  meeting_room_first: '请先选择会议室！',
  edit_meeting: '修改预约',
  view_meeting: '查看预约',
  userId: '员工工号：',
  welcome: '网易预约平台欢迎您',
  logout: '退出',
  holder_no_null: '申请人不能为空!',
  room_no_null: '会议室不能为空!',
  meeting_name_not_null: '会议主题不能为空!',
  meeting_name_less_than_3: '会议主题不能少于3个字符!',
  sign_time_no_null: '签到时间不能为空!',
  start_time_no_available: '会议开始时间不能小于当前时间！',
  hen_people: '代订人',
  time_limit: '时长不限',
  day_not_enable:
    '某些月份不足{ value } 天，对于这些月份，事件将被安排到该月的最后一天。',
  book_meeting_people_less: '参会人数不足,是否继续操作？',
  book_meeting_people_more: '参会人数超出会议室限制,是否继续操作？',
  meeting_room_delete_success: '会议室删除成功',
  meeting_room_delete_fail: '会议室删除失败',
  meeting_room_off_fail: '会议室下线失败',
  meeting_room_off_success: '会议室下线成功',

  room_types_common: '普通会议室',
  room_types_webex: 'WebEx会议室',
  room_types_acano: 'Acano会议室',
  room_types_exchange: 'Exchange会议室',
  room_types_domino_notes: 'Domino|Notes会议室',
  room_types_google_calendar: 'Google Calendar会议室',
  room_types_immediate: '红外即占即用会议室',
  room_types_cisco_cmma: 'Cisco视频会议室',

  //search
  time_type_month: '月',
  time_type_week: '周',
  time_type_day: '日',
  time_format_M: 'YYYY[年]M[月]',
  time_format_w: 'YYYY[年]M[月]',
  time_format_d: 'LL dddd',
  time_format_week: 'dddd',
  search_unit_person: '{num}人',
  search_right_menu_details: '查看详情',
  search_right_menu_edit: '修改会议',
  search_right_menu_cancel: '取消会议',
  time_expired: '该时间段已经过去，请选择合适的时间创建会议！',
  search_page_end: '不要再点了，已经到头了，没有其他数据了。',
  reservation_submit: '确认',
  search_room_close: '此时间段内会议室不可用。',
  re_last: '最后一个',
  domain_account: '域账号(员工工号)',
  domain_password: '域密码(员工开机密码)',
  quick_search: '快速搜索',
  welcome_info: '威思客智能会议欢迎您',
  index_login2: '我要登录',
  code_tips: '短信验证码已发送至您的手机',
  projector: '投影仪',
  phone: '电话',
  white_board: '白板',
  video: '视频设备',
  error_info_new: '知道了',
  head_portrait_max: '头像最大不能超过{num}KB',
  logo_max: 'LOGO最大不能超过{num}KB',
  background_max: '背景最大不能超过{num}MB',
  skin_max: '皮肤最大不能超过{num}MB',
  image_format_error: '图片格式可以为jpeg/jpg/png',
  image_upload_error: '上传失败，请稍后重试。',
  image_upload_not_null: '请选择人脸识别照片',
  meeting_right: '您没有查看此会议的权限',
  upload_excel: '该功能仅支持Excel格式的文件',
  user_id_tip: '用户ID只支持字母、数字、下划线以及横线',
  mobile_number_not_empty: '手机号码不能为空',
  mobile_number_format_error: '手机号码只能输入数字',
  domain_user_change: '域管理员无法修改自己的角色',
  image_user_upload_info:
    '推荐上传尺寸300*300像素，照片格式可以为jpeg/jpg/png，大小不超过500K.',
  image_bac_upload_info:
    '推荐上传尺寸1920*1080像素，照片格式可以为jpeg/jpg/png，大小不超过2M.',
  image_logo_upload_info:
    '推荐上传尺寸200*600像素，照片格式可以为jpeg/jpg/png，大小不超过500K.',
  more_meeting_booking: '多会议室预订',
  no_more_meeting: '没有可选的会议室',
  time_check: '最短30分钟，最长180分钟',
  id_number_not_empty: '用户ID不能为空',
  first_name_not_empty: '姓不能为空',
  give_name_not_empty: '名不能为空',
  email_not_empty: '邮箱不能为空',
  first_given_not_empty: '姓和名不能同时为空',
  user_not_login: '用户未登录，请先登陆',
  meeting_extend_time_null: '会议延长时间不能为空!',
  meeting_extend_time_success: '会议延长成功!',

  //iShow
  select_time: '选择时间',
  day_time: '日期+时间',
  //time out
  fetch_time_out: '请求超时，请检查网络。',
  //会议4.3
  add_more_meeting: '添加更多会议室',
  pls_more_meeting: '请选择区域',
  ordinary_meeting: '普通会议室',
  video_meeting: '视频会议室',
  meeting_type: '会议室类型',
  meeting_device: '会议室设备',
  meeting_search_device: '会议室设备',
  device_baiban: '白板',
  device_touying: '投影',
  device_video: '视频',
  device_phone: '电话',
  area_maintain: '区域维护',
  search_result: '{name}等 {num}个结果',
  meeting_management: '会议室管理员',
  meeting_rejected: '已拒绝',
  meeting_all_day: '全天会议',
  meeting_no_approved: '待审批',
  meeting_other_no_approved: '等待其他会议室管理员处理',
  meeting_agree: '已通过',
  remark_title: '备注（描述）',
  receipt_accept: '参加',
  receipt_no_accept: '不参加',
  receipt_back: '返回首页',
  regional_maintenance_title: '会议室管理列表',
  new_regional_maintenance: '新增区域',
  regional_maintenance: '区域管理',
  regional_maintenance_edit_tip: '此操作将放弃修改，是否继续？',
  regional_maintenance_edit_tip_placeholder: '请输入1-50个字符',
  department_maintenance_title: '部门设置',
  new_department_maintenance: '新增部门',
  department_maintenance_edit_tip: '此操作将放弃修改，是否继续？',
  department_maintenance_edit_tip_placeholder: '请输入1-20个字符',
  need_audit: '需审核',
  need_sign: '需签到',
  re_review: '待审核',
  zone_no_select: '没有符合条件的结果',
  pls_check_zone: '请选择区域',
  pls_check_dept: '请选择所属组织',
  pls_check_depart: '请选择部门',
  pls_check_default_dept: '请选择默认组织',
  pls_check_building: '请选择楼宇',
  pls_select_device: '请选择设备',
  group_name2: '名称',
  service_type: '服务类型',
  //应用管理
  application_management: '应用管理',
  upload_type: '类型',
  upload_NewVersion: '上传新版本',
  version_list: '版本列表',
  version: '版本号',
  version_profile: '版本简介',
  state: '状态',
  open: '开启',
  close: '关闭',
  upload_file: '上传文件',
  meeting_border: '会议展板',
  meeting_booking: '会议预约',
  format_error: '文件格式只能为apk类型',
  version_format_error: '请输入正确的版本号,格式为XXX.XXX.XXX(仅包含数字)',
  version_format: '版本简介，描述不超过50个汉字',
  download_title: '下载',
  meeting_signage: '会议展板',
  download_text1:
    '会议展板支持Outlook/Exchange、Google、OA、手机APP等多种会议室预订方式的消息推送及展示 ; 支持在展板上进行预订、签到、签退、延时等交互性操作。',
  download_text2: '智能会议展板下载',
  download_text3: '会议预约APP下载',
  download_text4: '会议预约APP下载',
  download_text5: 'Andriod 下载',
  download_text6: 'IOS 下载',
  download_text7: 'Andriod 下载',
  no_download: '无可用版本下载，请联系管理员！',
  upload_info_prompt: '请完善上传信息的必填项',
  re_reset: '重置',
  ex_status_link: '连接',
  ex_have_link: '已连接',
  ex_status_unlink: '断开连接',
  ex_have_unlink: '已断开',
  upload_success: '上传成功',
  select_file: '选择文件',
  loreal_check_in: '签到',

  // 报表
  report_report: '报表',
  report_search: '查询',
  report_meeting: '会议室',
  report_percent: '百分比',
  report_detail: '详情',
  report_meeting_title: '统计报表/会议室明细查询',
  report_meeting_list_title: '统计报表/会议预约报表',
  report_meeting_release_title: '统计报表/会议释放统计',
  report_room_occupy_title: '统计报表/会议室占用情况',
  report_area: '区域',
  report_meeting_name: '会议室名称',
  report_holder_name: '申请人',
  report_meeting_date: '会议日期',
  report_meeting_time: '会议时间',
  report_meeting_theme: '会议主题',
  report_room_name: '会议室名称',
  report_pls_name: '请输入会议室名称',
  report_pls_name_f: '输入多个会议室时请用;隔开',
  report_pls_holder_f: '请输入申请人姓名',
  report_room_place_holder: '请选择会议室',
  report_date: '日期',
  report_unit: '会议室*百分比',
  report_no: '序号',
  report_meeting_no: '会议数量',
  report_sign_num: '签到次数',
  report_sign_time: '签到时长',
  report_occupancy_time: '占用时长',
  report_occupancy_rate: '占用率',
  report_booking_rate: '预订率',
  report_use_rate: '使用率',
  report_disuse_rate: '弃用率',
  report_occupancy_info: '会议室占用情况',
  report_used_info: '会议室使用率详情',
  report_booking_disuse_info: '会议室预订次数与弃用次数对比',
  report_roomDetail_dayNum: '日期',
  report_roomDetail_bookNum: '预订次数',
  report_roomDetail_cancelNum: '取消次数',
  report_roomDetail_earlyNum: '提前结束次数',
  report_roomDetail_delayNum: '延长次数',
  report_roomDetail_disuseNum: '弃用次数',
  report_roomDetail_unSignNum: '未签到次数',
  report_roomDetail_unSignNames: '未签到名单',
  report_roomDetail_num: '次数',
  report_roomDetail_title: '统计报表/会议室占用率统计/会议室详情',
  report_roomDetail_back: '返回',
  report_roomDetail_chart: '会议室使用次数与未签到次数对比图',
  report_roomDetail_detail: '会议室占用率详情',
  report_occupancy_detail: '会议室占用情况一览',
  report_room_occupy_popular: '会议室使用时段热门指数',
  report_display: '显示更多列',
  report_custom: '自定义报表',
  report_custom_add: '新建报表',
  report_custom_delete: '删除',
  report_custom_view: '查看',
  report_custom_delete_confirm: '确认删除该自定义报表模板？',
  report_custom_name: '报表名称',
  report_custom_sql: 'SQL语句',
  report_custom_btn_excute: '执行SQL',
  report_custom_btn_save: '保存',
  report_custom_name_placeholder: '请输入报表名称',
  report_custom_sql_placeholder: '禁止的SQL关键字',
  report_custom_sql_null: '请输入SQL脚本',
  report_custom_sql_keyword_invalid: '非法的SQL关键字',
  report_custom_sql_fenhao_forbidden: '请勿使用分号',
  report_custom_sql_querry_success: '查询执行成功',
  report_custom_save_success: '报表保存成功',
  report_custom_delete_success: '报表删除成功',
  report_abnormal_detail_page: '异常使用详情',
  report_room_detail_page: '会议室详情',

  report_abnormal_statis_report: '统计报表',
  report_abnormal_meeting_statis: '会议室数据统计',
  report_abnormal_meeting_detail: '会议室数据统计/使用详情',
  report_abnormal_user_statis: '用户预订统计',
  report_abnormal_user_detail: '用户预订统计/使用详情',
  report_abnormal_back: '返回',
  report_abnormal_normal: '正常',
  report_abnormal_cancel: '取消',
  report_abnormal_extend: '延时',
  report_abnormal_normal_f: '按时结束',
  report_abnormal_cancel_f: '弃用',
  report_abnormal_extend_f: '延时结束',
  report_abnormal_early_end: '提前结束',
  report_abnormal_cancel_num: '弃用({num}次)',
  report_abnormal_extend_num: '延时结束({num}次)',
  report_abnormal_early_end_num: '提前结束({num}次)',
  report_abnormal_normal_num: '按时结束({num}次)',
  report_abnormal_detail_dept: '部门',
  report_abnormal_detail_creater: '预订人',
  report_abnormal_detail_meeting_name: '会议名称',
  report_abnormal_detail_meeting_time: '会议时间',
  report_abnormal_detail_operate_time: '操作时间',

  //report  user
  report_user_title: '统计报表/用户预订查询',
  report_user: '预订人',
  report_user_pls_name: '请输入姓名',
  report_user_pls_name_f: '输入多个姓名时用;隔开',
  report_user_dept: '部门',
  report_user_userDept: '部门',
  report_user_bookTimes: '预订次数',
  report_user_time: '预订时长',
  report_user_usage: '预订使用率',
  report_download: '导出报表',
  report_time_length: '时长',

  //service +
  service_room_img: '会议室图片',
  service_sign_noneed: '不签到',
  service_sign_password: '认证签到',
  service_sign_Invitation: '邀请码签到',
  service_sign_qr: '二维码签到',
  service_sign_face: '人脸识别签到',
  service_sign_anonymous: '匿名签到',

  meeting_file: '附件',
  meeting_file_upload: '上传附件',
  meeting_file_notice_0_size: '不能上传大小为0kb的文件!',

  meeting_cal_meeting_infor: '会议信息',

  meeting_reserve_status_status0: '未开始',
  meeting_reserve_status_status1: '已开始',
  meeting_reserve_status_status2: '已结束',
  meeting_reserve_status_status3: '已取消',
  meeting_reserve_status_status4: '审核拒绝',
  meeting_reserve_status_status5: '待审核',
  meeting_reserve_status_status6: '归档',

  meeting_status_2: '会议已结束',
  meeting_status_3: '会议已取消',

  meeting_remind_message_mail_webex_reason: '该会议不存在',
  meeting_remind_message_mail_webex_reason_holder: "该会议未开始,请提前十分钟进入",
  meeting_remind_message_mail_webex_reason0: '主持人未开启会议，请等待',
  meeting_remind_message_mail_webex_reason1: '该会议正在进行',
  meeting_remind_message_mail_webex_reason2: '该会议已经结束',
  meeting_remind_message_mail_webex_reason3: '该会议已经取消',
  meeting_remind_message_mail_webex_reason4: '该会议审核未通过',
  meeting_remind_message_mail_webex_reason5: '该会议正在审核',
  meeting_remind_message_mail_webex_reason6: '该会议已经开启',
  meeting_remind_message_mail_webex_reason7: '该会议暂未开始',
  meeting_remind_message_mail_webex_startWebex: '开启 Webex 会议',
  meeting_remind_message_mail_webex_joinWebex: '加入会议',
  meeting_remind_message_mail_webex_startTel: '开启 电话会议',
  meeting_reserve_message_mail_webex_name: '会议主题',
  meeting_reserve_message_mail_webex_rooms: '会议室',
  meeting_reserve_message_mail_webex_creator: '会议创建人',
  meeting_reserve_message_mail_webex_holder: '申请人',
  meeting_reserve_message_mail_webex_users: '会议参会人',
  meeting_reserve_message_mail_webex_startTime: '开始时间',
  meeting_reserve_message_mail_webex_endTime: '结束时间',
  meeting_reserve_message_mail_webex_remark: '备注(描述)',
  meeting_reserve_message_mail_webex_status: '会议状态',

  meeting_detail_webex_email_empty: 'Webex参会人邮箱不能为空！',

  board_no_data: '无',

  door_access_notice_msg: '请通过二维码扫描签到开门',

  smartDevice_notice_url_empty: '智能设备地址不能为空',
  smartDevice_notice_key_empty: '智能设备key不能为空',
  access_notice_url_empty: '门禁服务地址不能为空',
  access_notice_key_empty: '门禁服务client id不能为空',
  smart_device_server: '智能设备服务',
  smart_device_server_open: '开启智能设备服务',
  smart_device_placeholder_url: '服务地址',

  access_device_server: '门禁服务',
  access_device_server_open: '开启门禁服务',
  smart_device_button_save: '保存',
  access_device_placeholder_door_code:
    '输入多个门号时，门号之间请用英文","分隔',

  device_light: '智能灯',
  device_outlet: '智能插座',
  device_curtain: '智能窗帘',
  access_no: '门禁编号',

  smart_device_closed: '智能设备服务已关闭',
  access_device_closed: '门禁服务已关闭',

  smart_device_drop_down_no_data: '暂无数据',

  device_submit: '确定',
  device_fixed_title: '固定设备',
  device_fixed_name_label: '固定设备名称',
  device_fixed_num_label: '固定设备编号',
  device_fixed_name_empty: '请输入固定设备名称,建议加上设备型号',
  device_fixed_num_empty: '请输入固定设备编号:如:G-TV-01',
  device_mobile_title: '移动设备',
  device_mobile_name_label: '移动设备名称',
  device_mobile_nums_label: '移动设备数量',
  device_mobile_name_empty: '请输入移动设备名称',
  device_num_not_null: '设备编号不能为空',
  device_nums_not_null: '设备数量不能为空',
  device_name_not_null: '设备名称不能为空',
  service_device_select: '固定设备列表',
  service_device_selected: '已选择的固定设备',

  attend_select_amount: '已选择 {value} 人',
  attend_delete_user: '确认要删除用户{value}?',

  monitor_panel: '展板监控',
  monitor_panel_meeting_room: '会议室',
  monitor_panel_status: '状态',
  monitor_panel_search: '查询',
  monitor_panel_result: '查询结果：共 {value} 块展板异常',
  monitor_panel_area: '区域选择',
  monitor_panel_room_name: '会议室名称',
  monitor_panel_position: '展板位置描述',
  monitor_panel_operation: '操作',
  monitor_panel_repair: '修复异常',
  monitor_panel_delete: '删除监控',
  monitor_panel_status_all: '全部',
  monitor_panel_status_normal: '正常',
  monitor_panel_status_apperror: 'APP异常',
  monitor_panel_status_h5error: '页面异常',
  monitor_panel_more: '更多',
  monitor_panel_repair_APP: '重启APP',
  monitor_panel_repair_H5: '刷新界面',
  monitor_panel_repair_restart: '重启展板',
  monitor_panel_refresh_all: '全部刷新',
  monitor_panel_refresh_warning: '您确定要刷新吗？',

  monitor_alarm_set: '告警设置',
  monitor_alarm_frequency: '告警次数设置',
  monitor_alarm_every_set: '每次异常都告警',
  monitor_alarm_follow_set: '按照设置进行告警',
  monitor_alarm_every: '每',
  monitor_alarm_minutes: '分钟',
  monitor_alarm_times: '次异常进行告警',
  monitor_alarm_mailbox: '告警接收人邮箱',
  monitor_time: '监控时间段',
  monitor_alarm_input_rule: '输入多个邮箱时用 ; 隔开',
  monitor_alarm_apply: '应用',
  monitor_alarm_intervalTime_error: '请填写告警间隔时间！',
  monitor_alarm_frequency_error: '请填写告警次数！',
  monitor_alarm_email_error: '请填写正确邮箱格式！',

  application_size_lt_100: '应用文件大小不能超过100Mb',

  fault_yesterday_fault_statistics: '昨日故障统计',
  fault_7_fault_statistics: '7日故障统计',
  fault_fault_statistics: '故障统计',
  fault_7_fault_number: '7日故障数',
  fault_top5: '故障展板TOP5',
  fault_number_of_failures: '故障数',
  fault_failures_rate: '故障率',
  fault_times: '次',
  fault_select_time: '选择时间段',
  fault_select_time_placeholder: '请选择时间',
  fault_search_button: '查询',
  fault_number_of_failures_title: '故障次数',
  fault_time_error: '开始时间不能大于结束时间',
  fault_zone_error: '请选择区域后查询',

  //头像上传页面
  face_header_h4: '信息录入',
  face_header_p1: '您好',
  face_header_p2: '您有一些信息需要提交',
  face_body_name: '姓名：',
  face_body_dept: '部门：',
  face_body_face: '上传人脸识别照片：',
  face_body_select: '选择照片',
  face_body_submit: '提交',
  face_body_tip: '祝您工作愉快。',
  face_footer_tip1: '海银金融控股集团有限公司',
  face_footer_tip2: '联系电话：+86(21)8013 3999',

  //地图信息页面
  map_header_h4: '地图信息',
  map_header_p1: '您好',
  map_body_room: '会议室：',
  map_body_daoyin: '地图导引：',

  service_cleaning_manage_title:'保洁人员管理',
  service_back_to_service_manage_title:'返回服务管理',
  service_add_cleaning_manage_title:'添加保洁人员',
  service_new_level: '新增等级',
  service_new_item: '新增服务项',
  service_edit_item: '编辑服务项',
  service_item_manage: '服务项管理',
  service_level: '服务等级',
  service_item: '服务项',
  service_item_item: '服务项目',
  service_item_name: '服务名称',
  service_item_price: '单价',
  service_item_unit: '单位',
  service_item_type: '类别',
  service_item_select: '选择服务项',
  service_item_if_number: '是否数量',
  service_item_if_remark: '是否备注',
  yes: '是',
  no: '否',
  service_item_price_format: '格式：0.00',
  service_need_number: '是否需要数量',
  service_need_number_explain: '注：关闭后用户无需输入服务项的数量',
  service_need_remark: '是否需要备注',
  service_need_remark_explain: '注：关闭后用户无需输入备注信息',
  service_need_describe_explain:
    '该信息显示在用户端，打开开关为提示备注信息的说明输入框;关闭开关为显示文本信息',
  service_delete_data: '确定要删除该条数据吗？',
  service_level_error: '请填写服务等级名称！',
  service_level_same: '服务等级名称不能相同！',
  service_svcIds_error: '请至少选择一个服务项！',
  service_item_error: '请填写服务名称！',
  service_price_error: '请填写服务单价！',
  service_unit_error: '请填写服务单位！',
  service_type_error: '请选择服务类别！',
  service_remark_error: '请填写备注信息！',

  audit_reject_reason: '拒绝理由',
  audit_reject_reason_pre: '拒绝理由：',
  audit_reject_tip: '请输入拒绝理由',
  audit_svc_detail: '会议服务详情',
  audit_svc_audit: '会议服务审批',
  audit_svc_no_need_audit: '无需审批',
  audit_reject_tip_title: "审批信息：",

  //系统个性化设置
  per_a_1: '系统LOGO',
  per_a_2: '上传中文logo',
  per_a_3: '上传英文logo',
  per_a_4: '推荐上传200*600像素，照片格式可以为jpeg / jpg / png, 大小不超过2M',
  per_a_5: '会议展板LOGO及背景',
  per_a_6: '推荐上传350*100像素，照片格式可以为jpeg / jpg / png, 大小不超过2M',
  per_a_7: '背景',
  per_a_8:
    '推荐上传1280*800像素，照片格式可以为jpeg / jpg / png, 大小不超过10M',
  per_a_9: '短信签名',
  domain_sms_sign_hint: '短信签名不能为空，且需提前在短信平台申请',
  per_a_10: '保存',
  per_a_11: '邮件表头',
  per_a_12: '上传邮件表头',
  per_a_13:
    '推荐上传600*100像素，照片格式可以为jpeg / jpg / png, 大小不超过300K',
  per_a_14: '用户初始化密码设置',
  per_user_pwd_not_empty: '用户初始化密码不能为空！',
  per_a_15: '初始密码',
  per_a_16:'系统名称',
  per_a_17:'系统中文名称',
  per_a_18:'系统英文名称',
  per_b_1: '图片上传失败',
  per_b_2: '确认',
  per_b_3: '请选择正确的图片格式文件',
  per_b_4: '图片文件过大',
  per_b_5: '保存成功!',

  //模板管理
  boardman_1_0: '模板管理',
  boardman_2_0: '节能设置',
  boardman_2_1: '模式:',
  boardman_2_2: '禁用',
  boardman_2_3: '周期模式（每天）',
  boardman_2_4: '工作日模式（节假日关机）',
  boardman_2_5: '开机时间:',
  boardman_2_6: '关机时间:',
  boardman_2_7: '开机时间必须早于关机时间!',
  boardman_2_8: '保存',
  boardman_3_0: '版本更新',

  meeting_placeholder_start_date: '请选择开始日期',
  meeting_placeholder_end_date: '请选择结束日期',
  meeting_placeholder_name_id: '请输入会议主题或ID',
  meeting_placeholder_room: '请选择会议室',
  meeting_placeholder_remark: '请输入会议备注',
  meeting_btn_create_normal_meeting: '新建普通会议',
  meeting_btn_create_video_meeting: '新建视频会议',
  meeting_btn_mine_book: '我预约',
  meeting_btn_mine_attend: '我参会',
  meeting_btn_mine_manage: '我管理',
  meeting_list_header_status: '会议状态',
  meeting_list_header_convene: '会议所属',
  meeting_list_header_advanced_search: '高级搜索',
  meeting_list_table_id: '会议ID',
  meeting_list_table_subject: '会议主题',
  meeting_list_table_status: '状态',
  meeting_list_table_room: '会议室',
  meeting_list_table_start: '开始时间',
  meeting_list_table_end: '结束时间',
  meeting_list_table_creator: '申请人',
  meeting_list_table_operate: '操作',
  meeting_list_operate_cancelText: '是否取消此会议?',
  meeting_list_operate_stopText: '是否结束此会议?',
  meeting_list_operate_book_again: '再次预订',
  meeting_cancel_cmma_title: '视频会议仍在进行',
  meeting_cancel_cmma_text: '请在会控页面结束视频会议',

  cleaning_manage_name:'姓名',
  cleaning_manage_phone:'手机',
  cleaning_manage_email:'邮箱',
  cleaning_manage_list:'保洁人员管理',
  cleaning_manage_operate:'操作',
  role_manage_role_name: '角色名称',
  role_manage_permission: '权限分配',
  role_manage_operate: '操作',
  role_manage_user_list: '用户列表',
  role_manage_edit: '编辑',
  role_manage_delete: '删除',
  role_manage_delete_confirm: '确定要删除该角色吗？',
  role_manage_edit_role: '编辑角色',
  role_manage_all: '全部',
  role_manage_emp_name: '员工姓名',
  role_manage_time: '指定时间',
  role_manage_delete_user_role: '确定要删除该用户的角色吗？',
  role_manage_delete_user_role_fail1: '该用户已分配会议室，请先解除，再删除',
  role_manage_add_user_success: '用户添加成功！',
  role_manage_add_user_pls: '请选择要添加的用户！',
  role_manage_cant_del_your_self: '禁止删除当前用户的角色',

  user_add_sub_dept: '新增子部门',
  user_add_comp_dept: '新增子公司、子部门',
  main_btn_reset_pwd: '密码重置',
  main_search_keywords: '请输入搜索关键词',
  meeting_dept_user_add: '新增用户',
  meeting_dept_user_edit: '编辑用户',
  meeting_dept_user_import: 'Excel导入',
  meeting_dept_delete_confirm: '确定删除?',
  meeting_user_delete_confirm: '确定要删除该用户吗?',
  meeting_pwd_reset_confirm: '确定要重置该用户的密码吗?',
  meeting_dept_user_import_success: '导入成功',
  meeting_dept_user_file_failed: '文件上传失败',

  notice_manage_global_config: '全局通知配置',
  notice_manage_global_config_content:'预约会议成功后，默认所有参会人使用以下方式接收通知。',
  notice_manage_user_notice_config: '用户通知配置',
  notice_manage_user_notice_config_content: '预约会议时，预订人可选择接收通知的方式。',
  system_manage_meeting_admin_success: '设置会议室管理员成功',
  system_manage_delay_time_config: '会议延长配置',
  system_manage_delay_time_config_content: '设置会议延长的时间，设置PC端、展板端默认缺省延长的时长。',
  system_manage_delay_time_config_success: '会议延长配置保存成功',
  system_manage_delay_time_config_fail: '会议延长配置保存失败',
  system_manage_delay_time: '延长时长',
  system_manage_delay_time_desc: '分钟 （注：以"|"进行分割，最多不超过3个）',

  system_manage_infrared_check_time_title: '红外会议室无人检测时间',
  system_manage_infrared_check_time_desc: '会议进行中时，若红外会议室持续一段时间无人，会释放会议，或发送提醒邮件',
  system_manage_infrared_check_time_pre: '持续无人检测时间：',
  system_manage_infrared_check_time_warn: '请输入正确的无人检测时间！',
  system_manage_board_useing: '使用中',
  system_manage_board_error: '异常',
  system_manage_board_stop: '已停用',
  system_manage_board_start: '启用',

  notice_manage_sms: '短信',
  notice_manage_email: '邮件',
  notice_manage_vsk: '威思客',
  notice_manage_wechat: '微信',
  notice_manage_dd: '钉钉',
  work_day_label_select_year: '选择年份',
  work_day_label_working_hours: '工作时间',
  work_day_label_working_day: '工作日',
  work_day_label_Holiday: '节假日',
  work_day_setting: '设置',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  Sunday: '周日',
  work_day_btn_save: '保存',
  work_day_warning_work_hour: '请选择正确的工作时间！',
  work_day_working_day: '请选择工作日',
  work_day_remind: '是否将{date} {value}设为{holiday}?',

  log_manage: '日志管理',
  log_manage_placeholder_operate_type: '请选择操作类型',
  log_manage_placeholder_operator_id: '请输入操作者ID',
  log_manage_btn_query: '查询',
  log_manage_btn_reset: '重置',
  log_manage_operate_time: '操作时间',
  log_manage_operator: '操作人',
  log_manage_operate_type: '操作类型',
  log_manage_log_info: '日志详情',

  port_manage_protocol: '协议',
  port_manage_version: '版本',
  port_manage_ip: '地址',
  port_manage_account: '账号',
  port_manage_password: '密码',
  port_manage_describe: '描述',
  port_manage_btn_save: '保存',
  port_manage_btn_connect: '连接',
  port_manage_btn_disconnect: '断开连接',

  device_manage_add_mobile: '新增移动设备',
  device_manage_edit_mobile: '修改移动设备',
  device_manage_add_stable: '新增固定设备',
  device_manage_edit_stable: '修改固定设备',
  device_manage_back: '返回设备管理',
  device_manage_device_name: '设备名称',
  device_manage_device_name_cn: '设备中文名称',
  device_manage_device_name_en: '设备英文名称',
  device_manage_device_describe: '描述',
  device_manage_device_number: '数量',
  device_manage_floor: '所属区域',
  device_manage_cancel: '取消',
  device_manage_ok: '确定',
  device_manage_warning_empty_name: '设备名称不能为空！',
  device_manage_warning_empty_name_cn: '设备中文名称不能为空！',
  device_manage_warning_empty_name_en: '设备英文名称不能为空！',
  device_manage_warning_empty_number: '数量不能为空！',
  device_manage_warning_empty_floor: '楼层不能为空！',
  device_manage_operate: '操作',
  device_manage_edit: '编辑',
  device_manage_delete: '删除',
  device_manage_confirm_delete: '确定要删除该条数据吗？',
  device_manage_borrow_manage: '借用管理',
  device_manage_stable_manage: '固定设备管理',
  device_manage_mobile_manage: '移动设备管理',
  device_manage: '设备管理',
  device_manage_meeting_time: '会议时间',
  device_manage_meeting_title: '会议主题',
  device_manage_meeting_room: '会议室',
  device_manage_meeting_applier: '申请人',
  device_manage_meeting_device: '申请设备',
  device_manage_number: '数量',
  device_manage_lend_state: '借用状态',
  device_manage_warning_edit_success: '修改成功！',
  device_manage_warning_save_success: '保存成功！',
  device_manage_warning_delete_success: '删除设备成功！',
  device_manage_area: '区域',
  device_manage_lend: '借用',
  device_manage_give_back: '归还',
  device_manage_confirm_occupied: '该设备已被下列会议室占用：',
  device_manage_confirm_cannot_delete: '不允许删除！',
  device_manage_confirm_if_update: '是否仍要修改？',

  device_manage_state_lend_able: '可借用',
  device_manage_state_lending: '借用中',
  device_manage_state_give_back: '已归还',

  support_manage_front_empty: '暂无',
  support_manage_list: '会议支持列表',
  support_manage_receptionist_number: '前台号码',
  support_manage_name: '会议支持名称',
  support_manage_operate: '操作',
  support_manage_btn_add: '新增',
  support_manage_receptionist_edit: '编辑',
  support_manage_oprate_edit: '编辑',
  support_manage_oprate_delete: '删除',
  support_manage_edit_title: '编辑会议支持',
  support_manage_edit_ok: '确认',
  support_manage_edit_cancel: '取消',
  support_manage_edit_name: '会议支持名称',
  support_manage_edit_duplicate_name: '会议支持名称重复！',
  support_manage_edit_empty_name: '会议支持名称不能为空！',
  support_manage_delete_msg: '确定要删除该项会议支持吗？',

  service_need_upload_attachments: '是否上传附件',
  service_need_upload_attachments_attention: '注: 关闭后用户无法上传附件',
  service_need_approve: '是否需要审批',

  modal_manage_name: '模板名称',
  modal_manage_bind_meeting_name: '绑定会议室',
  modal_manage_operate: '操作',
  modal_manage_edit: '编辑',
  modal_manage_delete: '删除',
  modal_manage_add: '新增',

  modal_manage_version_title: '展板版本更新',
  modal_manage_version_name: '名称',
  modal_manage_version_name_placeholder: '请上传文件',
  modal_manage_version: '版本号',
  modal_manage_version_placeholder: '请输入版本号',
  modal_manage_version_create_user: '创建人',
  modal_manage_version_create_time: '创建时间',
  modal_manage_version_url: '下载地址',
  modal_manage_version_desc: '更新描述',
  modal_manage_version_status: '状态',
  modal_manage_version_file: 'Apk文件',
  modal_manage_version_desc_placeholder: '请输入更新描述',

  modal_manage_edit_title: '模板设置',
  modal_manage_edit_version_title: '上传安装包',
  modal_manage_btn_ok: '确认',
  modal_manage_btn_cancel: '取消',
  modal_manage_btn_end: '提前结束',
  modal_manage_edit_template_name: '模板名称',
  modal_manage_edit_template_name_placeholder: '请输入模板名称',
  modal_manage_edit_uploadlogo: '上传中文LOGO',
  modal_manage_edit_uploadlogo_hint:
    '图片格式可以为jpeg / jpg / png, 大小不超过500K',
  modal_manage_edit_eng_uploadlogo: '上传英文LOGO',
  modal_manage_edit_eng_uploadlogo_hint:
    '图片格式可以为jpeg / jpg / png, 大小不超过500K',
  modal_manage_edit_bg: '选择展板背景',
  modal_manage_edit_bg_hint:
    '要求上传尺寸为1280*768像素, 照片格式可以为jpeg / jpg / png, 大小不超过2M',
  modal_manage_meeting_room: '会议室',
  modal_manage_meeting_room_Occupy:
    '有会议室正在使用此模板，删除后将切换成默认模板',
  modal_manage_no_bg: '请上传展板背景',
  modal_manage_no_eng_logo: '请上传英文LOGO图片',
  modal_manage_no_logo: '请上传中文LOGO图片',
  modal_manage_no_template_name: '模板名称不能为空',
  board_manage_big_image: '图片文件过大',
  board_manage_has_apk: '已经存在文件',
  board_manage_big_apk: 'Apk文件过大',
  board_manage_error_image_format: '请选择正确的图片格式文件',
  board_manage_error_apk_format: '请上传apk文件',
  modal_manage_board_version_occupy: '是否启用此展板版本',

  upload_img_tip:
    '推荐上传尺寸为{w}*{h}像素，照片格式可以为jpeg/jpg/png/bmp，大小不超过{n}M',
  upload_img_isLt: '图片大小不能超过{n}M',

  room_manage_list_name: '会议室名称',
  room_manage_list_zoneFullName: '会议室区域',
  room_manage_list_adminUserName: '管理员',
  room_manage_list_qr: '二维码',
  room_manage_list_qr_title: '查看二维码',

  room_manage_list_oprate: '操作',

  room_manage_repair: '会议室维护',
  room_manage_list_visible: '启用状态',
  room_manage_device_repair: '设备维护',
  room_manage_no_device_repair: '该会议室没有需要维护的设备',

  room_manage_delete_msg: '是否删除此会议室？',
  room_manage_video_bind: '视频设备绑定',
  room_manage_video_bind_suc: '视频设备绑定成功！',
  room_manage_video_bind_fail: '视频设备绑定失败！',
  room_manage_video_delete_ok: '视频设备删除成功',
  room_manage_video_delete_fail: '视频设备删除失败',

  room_manage_add_meeting_room: '添加会议室',
  room_manage_Enable_meeting_room: '批量下线',
  room_manage_offline_msg: '是否批量下线该会议室?',
  room_manage_offRoomSelect_msg: '请至少选择一条数据?',
  room_manage_choose_meetingroom_admin: '请选择会议室管理员',
  room_manage_bind: '绑定',

  roomqr_manage: '查看二维码',
  roomqr_manage_close: '关闭',
  roomqr_manage_download: '下载',
  room_device_repair_title: '设备维护',

  room_device_fault: '故障',
  room_device_normal: '正常',
  room_manage_list: '会议室管理列表',

  room_add_modal_title:'新增会议室',
  room_edit_modal_title:'修改会议室',
  room_edit_room_name:'会议室名称',
  room_edit_room_nameEn:'会议室英文名称',
  room_edit_room_code:'会议室门号',
  room_edit_belong_area:'所属区域',
  room_edit_area:'区域',
  room_edit_floor:'楼层',
  room_edit_email:'邮箱',
  room_edit_people_number:'人数',
  room_edit_person:'人',
  room_edit_cost:'会议室使用费用',
  room_edit_unit_price:'元 / 小时',
  room_edit_room_type:'会议室类型',
  room_edit_placeholder_room_type:'请选择会议室类型',
  room_edit_allow_apply_svc:'允许申请会议服务',
  room_manage_organization:'所属组织',
  room_edit_sign_type:'签到类型',
  room_edit_placeholder_sign_type:'请选择签到类型',
  room_edit_need_audit:'是否需要审批',
  room_edit_usage:'是否启用',
  room_edit_room_manage:'会议室管理员',
  room_edit_fixed_device:'固定设备',
  room_edit_placeholder_fixed_device:'请选择固定设备',
  room_edit_room_image:'会议室图片',
  room_edit_room_order:'会议室排序序号',
  room_edit_placeholder_room_order:'请输入会议室排序号',
  room_edit_open_hw:'是否打开红外',
  room_edit_cancel:'取消',
  room_edit_ok:'确定',
  room_edit_admin_warning: "会议室管理员必须包含您自己！",
  room_edit_wrong_num: "会议室最大人数不能小于最小人数！",
  room_edit_device_maximum: '会议室固定设备不能多于5个',

  region_confirm_delete_record:'您确认删除这条记录吗？',
  report_placeholder_meeting_room:'请选择会议室',

  meeting_detail_start_now: '立即开始',

  meeting_tab_meeting_info: '会议信息',
  meeting_tab_meeting_service_apply: '会议服务申请',
  meeting_tab_meeting_sign: '签到管理',
  meeting_tab_meeting_agenda: '会议议程',
  meeting_tab_meeting_device_lend: '移动设备借用',

  meeting_device_add: '添加移动设备',
  meeting_device_search: '请输入设备名称搜索',
  meeting_device_type: '设备类型',

  meeting_info_initiate_auto: '自动发起',
  meeting_info_reconnect_auto: '自动重连',
  meeting_info_cospaces: '会议号',

  room_detail_room_type: '会议室类型',

  policy_manage_meeting_lock_time: '配置锁定时间',
  policy_manage_meeting_lock_time_content:
    '会议结束后,设置锁定一段时间再进行下一场会议',
  policy_manage_btn_save: '保存',
  policy_manage_meeting_willend_time: '会议结束提醒',
  policy_manage_meeting_willend_time_content: '会议结束前发送提醒通知的时间',

  policy_manage_meeting_remind_time: '会前提醒时间',
  policy_manage_meeting_remind_time_content: '会前发送提醒通知的时间',
  policy_manage_before_meeting_start:'会议开始前',

  policy_manage_unrepresented_reminder: '未参会人提醒',
  policy_manage_unrepresented_reminder_content:
    '给未参会人的人发送通知，配置会议展板上“提醒”按钮显示和隐藏的时间',
  policy_manage_meeting_check_in_time: '会议签到时间',
  policy_manage_meeting_check_in_time_content: '设置会议默认签到时间',
  policy_manage_meeting_lock: '一键锁定会议',
  policy_manage_meeting_lock_content: '锁定会议，红外无法释放会议',
  policy_manage_room_maintain: '一键维护会议室',
  policy_manage_room_maintain_content: '会议室维护中，不允许预约',
  policy_manage_display_board_btn_switch: '展板按钮开关',
  policy_manage_webex_btn_switch: 'WebEx会议设置',
  policy_manage_webex_btn_content: 'WebEx会议预约界面的设置',
  policy_manage_meeting_function_btn_switch: '会议功能开关',
  policy_manage_display_board_btn_content:
    '展板“预约”和“延长”、“结束”按钮和二维码是否显示的开关',
  policy_manage_meeting_function_btn_content:
    '关闭开关后，以下功能将不在预约流程中显示',
  policy_manage_meeting_cleaner_btn_switch: '保洁通知开关',
  policy_manage_meeting_cleaner_btn_content:
    '是否需要会议结束后给保洁员发送通知提醒',
  policy_manage_if_lock: '是否锁定',
  policy_manage_if_show: '是否显示',
  policy_manage_if_notice: '是否提醒',
  policy_manage_sign_time_label: '会议开始前/后',
  policy_manage_time: '时间',
  policy_manage_before_meeting: '会议开始前',
  policy_manage_after_meeting: '会议开始后',
  policy_manage_before_meeting_end: '会议结束前',
  policy_manage_minute: '分钟',
  policy_manage_day: '天',
  policy_manage_meeting_sign: '签到管理',
  policy_manage_meeting_svc: '会议服务',
  policy_manage_meeting_device: '移动设备',
  policy_manage_meeting_agenda: '会议议程',
  sign_meeting_befer_or_after: '会议开始前/后',
  need_room_admin_audit: '在该会议室预约会议需要会议室管理员审批',
  external_contacts: '外部联系人',
  imcomplete_external_info: '外部联系人信息不完整！',

  meeting_service_apply_title: '会议服务申请',
  meeting_service_apply_btn: '申请',
  meeting_service_apply_column_select: '选择',
  meeting_service_apply_column_service_type: '服务类型',
  meeting_service_apply_column_price: '单价',
  meeting_service_apply_column_number: '数量',
  meeting_service_apply_column_total: '小计(元)',
  meeting_service_apply_column_remark: '备注',
  meeting_service_apply_column_file: '附件',
  meeting_service_apply_label_total: '总计',
  meeting_service_apply_label_yuan: '元',

  meeting_apply_success: '申请成功!',
  meeting_save_success: '保存成功!',
  meeting_save_failed: '操作失败!',
  meeting_book_success: '预约成功!',
  meeting_cmma_number: '会议号',
  meeting_cmma_password: '会议密码',
  meeting_cancel_success: '会议取消成功!',
  meeting_send_msg: '发送通知',
  meeting_attends_inner: '内部参会人',
  meeting_attends_outer: '外部参会人',
  meeting_book_column_invite: '访问邀约',
  meeting_book_jurisdiction_fail: '您没有该会议室预订权限，请联系管理员!',

  personal_common_addr: '常用地：',
  personal_addr_config: '个人常用地址配置',

  app_index_conf_name: '功能名称',

  app_index_conf_cancel_show: '取消首页显示',
  app_index_conf_set_show: '设置首页显示',
  app_index_book: '预约会议',
  app_index_about: '关于',
  app_index_video_meeting: '视频会议',
  app_index_my_meeting: '我的会议',
  app_index_initiate: '发起会议',
  app_index_webex_meeting: 'WebEx会议',
  user_edit_cardNo: '门禁卡号',
  meeting_list_sign_state:'签到状态',
  meeting_list_table_not_sign: '未签到',
  meeting_list_table_sign:'已签到',

  room_maintain_start_label: '开始时间',
  room_maintain_end_label: '结束时间',
  room_maintain_start_pls: '请选择开始时间',
  room_maintain_end_pls: '请选择结束时间',
  room_maintain_start_empty: '开始时间不能为空',
  room_maintain_end_empty: '结束时间不能为空',
  room_maintain_status_normal: '正常',
  room_maintain_status_valid: '维护中',
  room_maintain_start_less_than_now:'开始时间不能小于当前时间',
  room_maintain_end_less_than_start:'结束时间不能小于开始时间',

  meeting_sign_btn_export:'导出',
  meeting_sign_label_sign_state:'状态',
  meeting_sign_label_has_sign:'已签到',
  meeting_sign_label_no_sign:'未签到',
  meeting_sign_label_sign_type:'方式',
  meeting_sign_label_sign_time:'时间',
  meeting_sing_label_unit_people:'人',
  meeting_sing_column_name:'姓名',
  meeting_sing_column_sign_time:'签到时间',
  meeting_sing_column_sign_type:'签到方式',
  meeting_sing_column_sign_img:'头像',
  meeting_sing_column_sign_operation:'操作',
  meeting_sign_column_resign:'补签',

  meeting_sing_type_none:'未签到',
  meeting_sing_type_pwd:'密码签到',
  meeting_sing_type_qr_code:'扫码签到',
  meeting_sing_type_face:'人脸识别签到',
  meeting_sing_type_infrared:'红外签到',
  meeting_sing_type_supplement:'预定人补签',
  meeting_sing_type_anonymous:'匿名签到',
  meeting_sing_type_door_access:'门禁签到',

  mt_rls_kind_cancel: '取消',
  mt_rls_kind_normal: '结束',
  mt_rls_kind_unsigned: '未签到释放',
  mt_rls_type_cancel: '主动取消',
  mt_rls_type_unsigned: '未签到',
  mt_rls_type_early: '提前结束',
  mt_rls_type_infrared: '红外释放',
  mt_rls_type_time_up: '正常结束',
  mt_rls_type_delay: '有延长',
  mt_rls_type_reject: '未批准',
  mt_rls_type_third_syn: '第三方同步',
  mt_rls_type_all_refused: '全部拒绝',
  mt_rls_type_room_maintain: '会议室维护',
  mt_rls_type_room_visible: '会议室不可用',
  license_title: 'license配置',
  license_subtitle:'配置系统license',
  license_label:'license：',

  sys_log_server_select: '服务选择',
  sys_log_search_date: '日期',
  sys_log_level: '日志级别',
  sys_log_download: '下载',
  sys_log_search_date_empty: '请选择日期',

  meeting_save_tips_subject:'主题',
  meeting_save_tips_holder:'申请人',
  meeting_save_tips_time:'时间',
  meeting_save_tips_reason:'原因',
  meeting_save_tips_lock_time:'锁定时间',
  meeting_save_tips_reason_0:'时间段被其他会议占用',
  meeting_save_tips_reason_1:'与其他会议锁定时间冲突',
  meeting_save_tips_reason_2:'该会议锁定时间被占用',
  meeting_save_tips_reason_3:'主持人已预约该时间段会议',
  meeting_tips_room_maintain:'会议室维护',
  meeting_tips_holiday:'节假日',

  meeting_save_tips_yes:'是',
  meeting_save_tips_no:'否',

  meeting_save_tips_modal_title1:'以下时间段预约失败,是否跳过并继续预订？',
  meeting_save_tips_modal_title2:'以下时间段预约失败，无可预约会议！',
  meeting_sign:'会议签到',
  sign_manage_need_attend:'需参会',
  sign_manage_unit_people:'人',
  sign_manage_sign: '签到',
  sign_manage_not_sign:'未签到',
  sign_manage_sign_state:'签到状态',
  sign_manage_sign_time:'签到时间',
  sign_manage_sign_operation:'操作',
  sign_manage_resign:'补签',
  sign_manage_status_has_sign:'已签到',
  sign_manage_img:'头像',
  sign_meeting_check_in_time:'签到时间',

  delay_meeting_sub_title:'请选择延长会议时间',
  delay_meeting_select_time: '{time}分钟',
  delay_meeting_wish_tip: '祝您工作愉快！',
  delay_meeting_bottom_wafer: '威发系统有限公司',
  delay_meeting_loop_recurrence: '会议周期',

  room_name_comm: '常用会议室',
  message_agenda_value1: '主题，时间，演讲人不能全部为空!',
  message_broadcast_value1: '直录播申请成功!',
  message_send_msg_success: '发送通知成功',
  message_send_msg_fail: '发送通知失败',

  meeting_agenda_speaker: '演讲人',

  // 会议服务
  meeting_services_info_value1: '请勾选需要的服务项！',
  meeting_services_info_value2: '已选择会议服务数量不能为空或为0!',
  meeting_services_info_value3: '已选择会议服务备注不能为空！',
  meeting_services_info_value4: '已选择会议服务需上传附件!',
  meeting_services_info_value5: '请选择移动设备',
  meeting_services_info_value6: '打开Exchange连接操作成功',
  meeting_services_info_value7: '更新状态成功',
  meeting_services_info_value8: '新增保洁人员',
  meeting_services_info_value9: '该服务需要会议服务管理员进行审批。',

  meeting_audit_fail_title: '审批失败！',

  user_check_user_id_info: '请填写用户ID！',
  user_check_user_name_info: '请填写姓名！',
  user_check_user_name_dep: '请选择部门！',

  room_editor_check_okText: '确认',
  room_editor_check_name: '会议室名称不能为空!',
  room_editor_check_nameEn: '会议室英文名称不能为空!',
  room_editor_check_ord_min: '会议室排序序号只能是整数且不小于1！',
  room_editor_check_ord_max: '会议室排序序号不能超过6位！',
  room_editor_check_zone: '所属区域不能为空!',
  room_editor_check_email: '邮箱不能为空!',
  room_editor_check_emailReg: '邮箱格式不正确!',
  room_editor_check_maxNumber: '会议室最大人数不能为空!',
  room_editor_check_minNumber: '会议室最大人数不能小于最小人数!',
  room_editor_check_adminUserId: '会议室管理员不能为空!',

  meeting_service_current_status: '当前状态为：',
  continue_book:'确认',
  cancel_book:'取消',
  cancel_apply:'取消申请',
  continue_apply:"继续申请",
  meeting_fee_notice:'预订会议金额',
  meeting_room_single_price:'会议室单价：',
  room_fee_unit_hour:'小时',
  room_fee_unit_minute:'分钟',
  room_fee_book_time:'预约时间：',
  room_fee_total:'会议室费用：',
  room_fee_during_time:'会议时长：',
  meeting_svc_fee_total:'会议服务费用：',
  meeting_fee_total:'总计：',
  notice_manage_label_billing:'是否计费',
  notice_manage_billing_titile:'预订会议室计费',
  notice_manage_billing_config_content:'预定会议时，会议室是否需要计费',
  yuan_every_hour:'元/小时',

  cross_days_meeting_days_limit:'预约会议天数不能小于 {num} 天！',
  notice_manage_title_crossday_meeting_min_day:'长期会议最小天数',
  notice_manage_subtitle_crossday_meeting_min_day:'预约长期会议时的最小天数差',
  notice_manage_label_crossday_meeting_min_day:'天数：',
  unit_day:'天',
  long_term_meeting_label:'长期会议：',

  meeting_list_selected_meeting_desc : '已选择 {num} 条数据',
  meeting_manage_batchCancel_meeting_msg: '确定取消该会议?',
  room_manage__meeting_batchCancel: '批量取消',

  meeting_bill_report: '统计报表',
  meeting_bill_report_time: '会议时间 :',
  meeting_bill_report_dept: '部门 :',
  meeting_bill_report_search: '查询',
  meeting_bill_report_reset: '重置',
  meeting_bill_report_return: '返回',
  meeting_bill_report_export: '导出',
  meeting_bill_report_dept_user: '部门/用户',
  meeting_bill_report_room_price: '会议室费用（元）',
  meeting_bill_report_svc_price: '会议服务费用（元）',
  meeting_bill_report_total_price: '总计（元）',
  price_free:'免费',

  // web端菜单国际化
  menu_meeting_booking: '会议预约',
  menu_meetings: '会议列表',
  menu_system_configuration: '系统配置',
  menu_cole_management: '角色管理',
  menu_meeting_panel_management: '展板管理',
  menu_meeting_room_management: '会议室管理',
  menu_meeting_service_management: '会议服务管理',
  menu_device_danagement: '设备管理',
  menu_interface_setting: '接口设置',
  menu_log_lanagement: '日志管理',
  menu_report: '统计报表',
  menu_room_usage_report: '会议室明细查询',
  menu_user_usage_report: '用户预订查询',
  menu_abnormal_room_report: '会议室数据统计',
  menu_abnormal_user_report: '用户预订统计',
  menu_meeting_report: '会议预约报表',
  menu_workday_management: '工作日管理',
  menu_system_management: '系统管理',
  menu_enterprise_info: '企业信息',
  menu_meeting_panel_monitor_img: '展板监控',
  menu_meeting_panel_monitor: '展板监控',
  menu_fault_statistics: '故障统计',
  menu_approval: '会议审批',
  menu_meeting_approval: '会议审批',
  menu_meeting_service_approval: '会议服务审批',
  menu_department_user_management: '组织用户管理',
  menu_panel_alarm: '展板告警',
  menu_personal_information: '个人信息',
  menu_enterprise_setting: '企业信息配置',
  menu_meeting_release_report: '会议释放统计',
  menu_room_occupy_report: '会议室占用情况',
  menu_meeting_bill_report: '会议计费报表',

};



// WEBPACK FOOTER //
// ./src/i18n/zh_CN/index.js